var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubeRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.365 5.933 8 7.41 1.806 3.54 7.504.283a1 1 0 0 1 .992 0l.64.365a3.001 3.001 0 0 0 1.228 5.283ZM15 6v5.42a1 1 0 0 1-.504.868L8.5 15.714V8.277L12.143 6H15ZM1.056 4.25 7.5 8.277v7.437l-5.996-3.426A1 1 0 0 1 1 11.42V4.58a1 1 0 0 1 .056-.33ZM11 2h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeRemove);
export default __webpack_public_path__ + "static/media/cube-remove.1a3893b38c87dfb9111e88ecf18ba02e.svg";
export { ForwardRef as ReactComponent };